import React from 'react';
import { Link } from '@tanstack/react-router';
import { useQueryTable } from '@/hooks/useQueryTable';
import { getGetDocumentsQueryOptions } from '@area-restrita/api-client/endpoints/company-document/company-document.gen';
import { CompanyDocumentQueryData } from '@area-restrita/api-client/model/companyDocumentQueryData';

import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Table, TableBody } from '@/components/ui/table';
import { DataTableBody } from '@/components/DataTable';
import { Badge } from '@/components/ui/badge';
import { Separator } from '@/components/ui/separator';

const DocumentsCard: React.FC<{ className?: string }> = ({ className }) => {
  const {
    query: { data, isLoading },
    table,
  } = useQueryTable<CompanyDocumentQueryData>({
    columns: [
      {
        id: 'name',
        header: 'Nome',
        cell: ({ row }) => (
          <span className="flex items-center gap-2 pl-6 text-base text-blue-700">
            <div className="w-4 h-4 bg-blue-700 rounded-sm" />
            {row.original.name}
          </span>
        ),
      },
      {
        id: 'categoryIds',
        header: 'Categoria',
        cell: ({ row }) => (
          <div className="flex flex-col items-end pr-6">
            <Badge>{row.original.documentCategory?.description ?? 'N/A'}</Badge>
          </div>
        ),
      },
    ],
    getQueryOptions: getGetDocumentsQueryOptions,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 4,
      },
    },
  });

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>Documentos</CardTitle>
        <CardDescription>
          {data?.total ?? 'N/A'} documento(s) cadastrado(s)
        </CardDescription>
      </CardHeader>
      <CardContent className="px-0 pt-0 pb-6">
        <Table>
          <TableBody>
            <DataTableBody table={table} isLoading={isLoading} />
          </TableBody>
        </Table>
      </CardContent>
      <Separator />
      <CardFooter className="flex justify-end pt-6">
        <Link
          className="text-sm underline-offset-4 hover:underline"
          to="/documents"
        >
          Ver todos os documentos
        </Link>
      </CardFooter>
    </Card>
  );
};

export default DocumentsCard;
